import { render } from "./ProductCCTV.vue?vue&type=template&id=4cdbee08"
import script from "./ProductCCTV.vue?vue&type=script&lang=js"
export * from "./ProductCCTV.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__